import React from "react";
import { withNamespaces } from 'react-i18next';

const AcViver = ({t}) => {
  return (
    <>
      <div className="accordion" id="accordionExample_viver">
        {/* 1*/}
        <div className="accordion-item">
          <h2 className="accordion-header" id="viver_heading1">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#viver_collapse1"
              aria-expanded="true"
              aria-controls="viver_collapse1"
            >
              {t('moduleFaqs:S6.A.A1.T') }
            </button>
          </h2>
          <div
            id="viver_collapse1"
            className="accordion-collapse collapse"
            aria-labelledby="viver_heading1"
            data-bs-parent="#accordionExample_viver"
          >
            <div className="accordion-body">
              <p className="p_accordion" dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S6.A.A1.P1') }}>
              </p>
              <p className="p_accordion" dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S6.A.A1.P2') }}></p>
            </div>
          </div>
        </div>
        {/* 2*/}
        <div className="accordion-item">
          <h2 className="accordion-header" id="viver_heading2">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#viver_collapse2"
              aria-expanded="true"
              aria-controls="viver_collapse2"
            >
              {t('moduleFaqs:S6.A.A2.T') }
            </button>
          </h2>
          <div
            id="viver_collapse2"
            className="accordion-collapse collapse"
            aria-labelledby="viver_heading2"
            data-bs-parent="#accordionExample_viver"
          >
            <div className="accordion-body">
              <p className="p_accordion" dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S6.A.A2.P1') }}></p>
              <p className="p_accordion" dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S6.A.A2.P2') }}></p>
            </div>
          </div>
        </div>
        {/* 3*/}
        <div className="accordion-item">
          <h2 className="accordion-header" id="viver_heading3">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#viver_collapse3"
              aria-expanded="true"
              aria-controls="viver_collapse3"
            >
              {t('moduleFaqs:S6.A.A3.T') }
            </button>
          </h2>
          <div
            id="viver_collapse3"
            className="accordion-collapse collapse"
            aria-labelledby="viver_heading3"
            data-bs-parent="#accordionExample_viver"
          >
            <div className="accordion-body">
              <p className="p_accordion">
                {t('moduleFaqs:S6.A.A3.P') }
              </p>
            </div>
          </div>
        </div>
        {/* 4*/}
        <div className="accordion-item">
          <h2 className="accordion-header" id="viver_heading4">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#viver_collapse4"
              aria-expanded="false"
              aria-controls="viver_collapse4"
            >
              {t('moduleFaqs:S6.A.A4.T') }
            </button>
          </h2>
          <div
            id="viver_collapse4"
            className="accordion-collapse collapse"
            aria-labelledby="viver_heading4"
            data-bs-parent="#accordionExample_viver"
          >
            <div className="accordion-body">
              <p className="p_accordion" dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S6.A.A4.P') }}></p>
            </div>
          </div>
        </div>
        {/* 5*/}
        <div className="accordion-item">
          <h2 className="accordion-header" id="viver_heading5">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#viver_collapse5"
              aria-expanded="false"
              aria-controls="viver_collapse5"
            >
              {t('moduleFaqs:S6.A.A5.T') }
            </button>
          </h2>
          <div
            id="viver_collapse5"
            className="accordion-collapse collapse"
            aria-labelledby="viver_heading5"
            data-bs-parent="#accordionExample_viver"
          >
            <div className="accordion-body">
              <p className="p_accordion" dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S6.A.A5.P') }}></p>
            </div>
          </div>
        </div>

        {/* 6*/}
        <div className="accordion-item">
          <h2 className="accordion-header" id="viver_heading6">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#viver_collapse6"
              aria-expanded="false"
              aria-controls="viver_collapse6"
            >
              {t('moduleFaqs:S6.A.A6.T') }
            </button>
          </h2>
          <div
            id="viver_collapse6"
            className="accordion-collapse collapse"
            aria-labelledby="viver_heading6"
            data-bs-parent="#accordionExample_viver"
          >
            <div className="accordion-body">
              <p className="p_accordion" dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S6.A.A6.P1') }}></p>
              <p className="p_accordion" dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S6.A.A6.P2') }}></p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withNamespaces() (AcViver);
